import Paper from "@mui/material/Paper";
import TextField from "components/TextFieldInput";
import { PROP_TYPES, DEFAULT_STATE } from "pages/order/prop-types";
import { StyledShipTo, ShipToRow, WorkOrderHeading } from "styles/pages/order";

const SalesOrderBillTo = ({ state, setState }) => {
  const billTo = state?.billTo;

  return (
    <Paper elevation={3}>
      <WorkOrderHeading>Bill To</WorkOrderHeading>
      <StyledShipTo>
        <ShipToRow>
          <TextField
            label="Bill Name"
            error={!billTo?.billName?.trim()}
            value={billTo?.billName}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, billName: e?.target?.value },
              })
            }
          />
        </ShipToRow>

        <ShipToRow>
          <TextField
            label="Address 1"
            error={!billTo?.address1?.trim()}
            value={billTo?.address1}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, address1: e?.target?.value },
              })
            }
          />

          <TextField
            label="Address 2"
            value={billTo?.address2}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, address2: e?.target?.value },
              })
            }
          />
        </ShipToRow>

        <ShipToRow style={{ marginBottom: 0 }}>
          <TextField
            label="City"
            error={!billTo?.city?.trim()}
            value={billTo?.city}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, city: e?.target?.value },
              })
            }
          />

          <TextField
            label="State"
            error={!billTo?.state?.trim()}
            value={billTo?.state}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, state: e?.target?.value },
              })
            }
          />

          <TextField
            label="Country"
            error={!billTo?.country?.trim()}
            value={billTo?.country}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, country: e?.target?.value },
              })
            }
          />

          <TextField
            label="Zip"
            error={!billTo?.zip?.trim()}
            value={billTo?.zip}
            handleChange={(e) =>
              setState({
                ...state,
                billTo: { ...billTo, zip: e?.target?.value },
              })
            }
          />
        </ShipToRow>
      </StyledShipTo>
    </Paper>
  );
};

SalesOrderBillTo.propTypes = PROP_TYPES;

SalesOrderBillTo.defaultProps = DEFAULT_STATE;

export default SalesOrderBillTo;
